import { render, staticRenderFns } from "./AdiNeuropsychiatricInventoryComponent.vue?vue&type=template&id=93f323be"
import script from "./AdiNeuropsychiatricInventoryComponent.vue?vue&type=script&lang=js"
export * from "./AdiNeuropsychiatricInventoryComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports